import React from 'react';
import ScrollToTop from '../../../shared/utils/scrollToTop';
import { Row, Col } from '@snsw/react-component-library';
import styles from './PlantDesignReview.module.scss';

import { useSelector } from 'react-redux';
import { PagePath } from 'shared/constants/pagePath';
import { SummaryCard } from '@onegov/react-component-library';
import { ApplicantDetailsReview } from './components/ApplicantDetailsReview';
import { DesignDetailsReview } from './components/DesignDetailsReview';
import { RegistrationTypeReview } from './components/RegistrationTypeReview';
import { DrawingsAndTechnicalStandardsReview } from './components/DrawingsAndTechnicalStandardsReview';
import { DesignerAndDesignVerifierReview } from './components/DesignerAndDesignVerifierReview';
import { PasswordlessContinueSaveExitButtons } from 'shared/components/formNavigationButtons/PasswordlessContinueSaveExitButtons';
import { HolderDetailsReview } from './components/HolderDetailsReview';
import { useNavigate } from 'react-router-dom';
import { PlantDesignConstants } from 'plantDesign/constants/plantDesignConstants';

export const PlantDesignReview = (props) => {
  ScrollToTop();
  const navigate = useNavigate();

  const applicantDetails = useSelector((state) => state.plantDesignApplicantDetails);
  const holderDetails = useSelector((state) => state.plantDesignHolderDetails);
  const designDetails = useSelector((state) => state.plantDesign);
  const drawingAndTech = useSelector((state) => state.plantDesignDrawingAndTech);
  const designerAndDesignVerifierDetails = useSelector((state) => state.plantDesignVerifier);
  const refData = useSelector((state) => state.plantDesignReferenceData);

  const getStatus = (isComplete) => {
    if (isComplete) {
      return {
        text: 'Complete',
        variant: 'success',
      };
    }

    return {
      text: 'Incomplete',
      variant: 'neutral',
    };
  };

  const onContinueClick = () => {
    if (areAllCompleted()) navigate(PagePath.plantDesignDeclaration);
  };

  const onBackClick = () => {
    navigate(PagePath.plantDesignDesignerVerifierDetails);
  };

  const areAllCompleted = () => {
    return (
      applicantDetails.isCompleted &&
      holderDetails &&
      designDetails.isCompleted &&
      drawingAndTech.isCompleted &&
      designerAndDesignVerifierDetails.isCompleted
    );
  };

  return (
    <>
      <Row className={styles.summary}>
        <Col span={8}>
          <SummaryCard
            id="applicant-details-review"
            title="Your details"
            actionProps={{
              onClick: () => {
                navigate(PagePath.plantDesignApplicantDetails);
              },
              text: 'Edit',
            }}
            defaultCollapsed={true}
            status={getStatus(applicantDetails.isCompleted)}
          >
            <ApplicantDetailsReview data={applicantDetails} />
          </SummaryCard>
        </Col>
      </Row>
      <Row className={styles.summary}>
        <Col span={8}>
          <SummaryCard
            id="registration-holder-details-review"
            actionProps={{
              onClick: () => {
                navigate(PagePath.plantDesignRegistrationHolder);
              },
              text: 'Edit',
            }}
            title="Registation holder details"
            defaultCollapsed={true}
            status={getStatus(holderDetails.isCompleted)}
          >
            <HolderDetailsReview holderDetails={holderDetails} applicantDetails={applicantDetails} />
          </SummaryCard>
        </Col>
      </Row>
      <Row className={styles.summary}>
        <Col span={8}>
          <SummaryCard
            id="design-details-review"
            title="Plant design details"
            actionProps={{
              onClick: () => {
                navigate(PagePath.plantDesignDetails);
              },
              text: 'Edit',
            }}
            defaultCollapsed={true}
            status={getStatus(designDetails.isCompleted)}
          >
            <RegistrationTypeReview data={designDetails} />
            <br></br>
            <DesignDetailsReview data={designDetails} refData={refData} />
          </SummaryCard>
        </Col>
      </Row>
      <Row className={styles.summary}>
        <Col span={8}>
          <SummaryCard
            id="drawings-and-technical-standards-review"
            title="Drawings and technical standards"
            actionProps={{
              onClick: () => {
                navigate(PagePath.plantDesignDrawingAndTechnicalDetails);
              },
              text: 'Edit',
            }}
            defaultCollapsed={true}
            status={getStatus(drawingAndTech.isCompleted)}
          >
            <DrawingsAndTechnicalStandardsReview drawingsAndTechStandards={drawingAndTech} />
          </SummaryCard>
        </Col>
      </Row>
      <Row className={styles.summary}>
        <Col span={8}>
          <SummaryCard
            id="designer-and-design-verifier-review"
            title="Designer and design verifier"
            actionProps={{
              onClick: () => {
                navigate(PagePath.plantDesignDesignerVerifierDetails);
              },
              text: 'Edit',
            }}
            defaultCollapsed={true}
            status={getStatus(designerAndDesignVerifierDetails.isCompleted)}
          >
            <DesignerAndDesignVerifierReview designerAndDesignVerifierDetails={designerAndDesignVerifierDetails} />
          </SummaryCard>
        </Col>
      </Row>
      <PasswordlessContinueSaveExitButtons
        onContinueClick={onContinueClick}
        onBackClick={onBackClick}
        licenceType={PlantDesignConstants.licenceType}
      />
    </>
  );
};
